import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Alert, Button } from 'react-bootstrap';
import _, { find as _find } from 'lodash';
import { createObjectURL } from 'helpers/upload';
import { Tooltip } from 'react-tooltip';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import EXIF from 'exif-js';
import { confirmAlert } from 'js/wrapper/CustomConfirmAlert';
import { S3_LINKS } from 'js/constants';
import ImageEditorFTs from 'cc-editor/helpersTs/ImageEditorFTs';
import Loader from '../../../components/layout/Loader';
import EditorApplyStylesFTs from '../EditorApplyStylesFTs';
import MediaTabsFTs from '../MediaTabsFTs';
import FormInput from '../../../components/forms/FormInput';
import { getCorporateDesignClient, getCorporateDesignLogoUrl } from 'cc-editor/helpers/corporateDesign';
// Portal container to render modal overlays outside the current DOM hierarchy
const ContextModal = ({ children }) => {
    return ReactDOM.createPortal(children, document.getElementById('context-modal'));
};
const ImageElementFTs = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { attributes, id, name, params, usedMedia, templateId, rootUser, disabled, uploadError, saveDescription, imageUpload, updateParam, settings, appIntl, clientImageRightsQuery, editionRV, } = props;
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : {};
    const Tag = name;
    // DOM References
    const imageRef = useRef(null);
    const inputElement = useRef(null);
    const [isEditorLoaded, setIsEditorLoaded] = useState(false);
    const [state, setState] = useState({
        showImageTooSmallError: false,
        showImageEditor: false,
        showMedia: false,
        editorImageSrc: null,
        imageSrc: null,
        imageKey: null,
        xZoom: 1,
        imgWidth: 0,
        imgHeight: 0,
        imgFilename: '',
        imgThumb: '',
        imgCopyright: '',
        path: '',
        imgBlockWidth: 0,
        imgBlockHeight: 0,
        imageDescription: '',
        showDescriptionInputField: true,
        scaleFree: false,
        allowSmallerImages: false,
        cropperKey: 0,
        rotation: 0,
        flipX: false,
        flipY: false,
    });
    const { showImageTooSmallError, showImageEditor, showMedia, editorImageSrc, imgWidth, imgHeight, imgBlockWidth, imgBlockHeight, imageDescription, showDescriptionInputField, allowSmallerImages, } = state;
    // Measures parent container dimensions in the DOM to set minimum required crop resolution
    useEffect(() => {
        const updateSize = () => {
            if (imageRef.current) {
                const parent = imageRef.current.offsetParent;
                if ((parent === null || parent === void 0 ? void 0 : parent.offsetWidth) > 0 && (parent === null || parent === void 0 ? void 0 : parent.offsetHeight) > 0) {
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { imgBlockWidth: parent.offsetWidth, imgBlockHeight: parent.offsetHeight })));
                }
            }
        };
        updateSize();
    }, [
        (_d = (_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.offsetParent) === null || _d === void 0 ? void 0 : _d.offsetWidth,
        (_f = (_e = imageRef.current) === null || _e === void 0 ? void 0 : _e.offsetParent) === null || _f === void 0 ? void 0 : _f.offsetHeight,
    ]);
    /* Todo - we should replace the useEffect to update size via updateSize() with resizeObserver because it is supposed to be more reliable, still not tested - check in the future */
    /*
      useEffect(() => {
      if (!imageRef.current) return;
  
      const parent = imageRef.current.offsetParent as HTMLElement;
      if (!parent) return;
  
      const resizeObserver = new ResizeObserver(() => {
        if (parent.offsetWidth > 0 && parent.offsetHeight > 0) {
          setState((prevState) => ({
            ...prevState,
            imgBlockWidth: parent.offsetWidth,
            imgBlockHeight: parent.offsetHeight,
          }));
        }
      });
  
      resizeObserver.observe(parent);
      return () => resizeObserver.disconnect();
    }, []); // Empty array, since the observer reacts dynamically to size changes!
     */
    // Resets cropper control values to defaults
    const resetCropperImage = () => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { xZoom: 1, rotation: 0, flipX: false, flipY: false })));
    };
    // Toggles fixed aspect ratio locking vs. free-scale cropping
    const setCropperScaleFree = (value) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { scaleFree: value })));
    };
    // Converts Base64 data URIs into standard binary Blob objects for file uploads
    const DataURIToBlob = (dataURI) => {
        const splitDataURI = dataURI.split(',');
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i);
        return new Blob([ia], { type: mimeString });
    };
    // Shows user copyright and image usage permission confirmation popup
    const imagePermissionQuery = () => {
        const options = {
            customUI: ({ onClose }) => {
                return (_jsxs("div", { className: "react-confirm-alert-body", style: { width: '100%' }, children: [_jsx("h1", { children: messages.image_permission_title }), _jsx("p", { children: messages.image_permission_warning }), _jsxs("div", { className: "react-confirm-alert-button-group", style: { width: '100%', margin: '0 auto' }, children: [_jsx(Button, { style: { margin: '5px', width: '100px' }, variant: "primary", onClick: () => {
                                        onClose();
                                        handleIEclose();
                                    }, children: messages.no }), _jsx(Button, { style: { margin: '5px', width: '100px' }, variant: "warning", onClick: () => {
                                        onClose();
                                    }, children: messages.yes })] })] }));
            },
            childrenElement: () => _jsx("div", {}),
            closeOnEscape: false,
            closeOnClickOutside: false,
        };
        confirmAlert(options);
    };
    // Updates template parameter store with new image preview URL and copyright info
    const update = (value, copyright, resolutionWarning) => {
        const overflow = false;
        const default_image = false;
        const resolution_warning = resolutionWarning;
        const errors = [{ overflow, default_image, resolution_warning }];
        const finalCopyright = copyright || '';
        updateParam(id, attributes['data-name'], value, errors, 'copyright_' + attributes['data-name'], finalCopyright);
    };
    // Handles finalized crop data from canvas, exports preview URL, and triggers backend upload
    const imageUploadHandler = (canvas, cropData, resolutionWarning, filterAsString) => {
        var _a;
        try {
            // 1. Determine the MIME type of the source image
            const mimeType = ((_a = state.imageSrc) === null || _a === void 0 ? void 0 : _a.type) || '';
            const isTransparent = mimeType === 'image/png' || mimeType === 'image/webp';
            // 2. Export images with transparency as PNG; otherwise, as JPEG.
            const image = canvas.toDataURL(isTransparent ? 'image/png' : 'image/jpeg', 0.95);
            const { imageSrc, imageKey, imgWidth, imgHeight, imgFilename, imgThumb, imgCopyright, imageDescription } = state;
            const imageBlob = DataURIToBlob(image);
            const imageUrl = URL.createObjectURL(imageBlob);
            update(imageUrl, imgCopyright, resolutionWarning);
            const overflow = false;
            const default_image = false;
            const resolution_warning = resolutionWarning;
            const errors = { overflow, default_image, resolution_warning };
            imageUpload(id, imageSrc, imageKey, attributes['data-name'], cropData, imgWidth, imgHeight, imgFilename, imgThumb, imgCopyright, null, null, null, imageDescription, false, 0, 0, 0, errors, filterAsString);
            // Close modal and clean up state
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { showImageTooSmallError: false, showMedia: false, showImageEditor: false, xZoom: 1, editorImageSrc: null, rotation: 0, flipX: false, flipY: false })));
        }
        catch (e) {
            console.error('Canvas export failed:', e);
        }
    };
    // Resolves actual image URL from parameters, preset dynamic logos, or fallback placeholder
    const getSrc = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const param = _find(params, ['name', attributes['data-name']]);
        if (param) {
            return param.value;
        }
        if (attributes.src) {
            if (attributes.src === '{logoBlack}' || attributes.src === '{logoWhite}' || attributes.src === '{logoColored}') {
                const cdClient = getCorporateDesignClient(editionRV) || (settings === null || settings === void 0 ? void 0 : settings.target);
                if (attributes.src === '{logoBlack}') {
                    return getCorporateDesignLogoUrl(cdClient, 'client_main_logo')
                        || ((_e = (_d = (_c = (_b = (_a = settings === null || settings === void 0 ? void 0 : settings.target) === null || _a === void 0 ? void 0 : _a.client_main_logo) === null || _b === void 0 ? void 0 : _b.variations) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.file) === null || _e === void 0 ? void 0 : _e.web_link);
                }
                if (attributes.src === '{logoWhite}') {
                    return getCorporateDesignLogoUrl(cdClient, 'client_main_logo_white')
                        || ((_k = (_j = (_h = (_g = (_f = settings === null || settings === void 0 ? void 0 : settings.target) === null || _f === void 0 ? void 0 : _f.client_main_logo_white) === null || _g === void 0 ? void 0 : _g.variations) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.file) === null || _k === void 0 ? void 0 : _k.web_link);
                }
                return getCorporateDesignLogoUrl(cdClient, 'client_main_logo_multi_colored')
                    || ((_q = (_p = (_o = (_m = (_l = settings === null || settings === void 0 ? void 0 : settings.target) === null || _l === void 0 ? void 0 : _l.client_main_logo_multi_colored) === null || _m === void 0 ? void 0 : _m.variations) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.file) === null || _q === void 0 ? void 0 : _q.web_link);
            }
            return attributes.src;
        }
        return 'nopic.jpg';
    };
    // Loads original uncropped image from S3 storage into editor modal
    const loadOriginal = (e, option) => {
        const original = attributes['data-original'];
        const originalSrc = S3_LINKS.MEDIA_IMGS_ORIGINAL + original;
        const imgC = new Image();
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showDescriptionInputField: option })));
        imgC.crossOrigin = 'anonymous';
        imgC.src = originalSrc;
        imgC.onload = () => {
            const imgwidth = imgC.width;
            const imgheight = imgC.height;
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { showImageTooSmallError: false, showMedia: false, showImageEditor: true, editorImageSrc: { src: originalSrc }, imageSrc: null, imageKey: original, imgWidth: imgwidth, imgHeight: imgheight, imgThumb: '', imgCopyright: '' })));
        };
    };
    // Loads external/stock media items (e.g., Pixabay or Media Library) into editor modal
    const loadMedia = (original, path, filename = '', thumb = '', copyright = '', files) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showDescriptionInputField: true })));
        let originalSrc = original === 'tp' ? path : `${path}${original}`;
        if (original === 'pixabay') {
            originalSrc = path;
            original = path;
        }
        const imgC = new Image();
        imgC.crossOrigin = 'anonymous';
        imgC.src = originalSrc;
        imgC.onload = () => {
            const imgwidth = imgC.width;
            const imgheight = imgC.height;
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { showImageTooSmallError: false, showMedia: false, showImageEditor: true, editorImageSrc: { src: originalSrc }, imageSrc: original === 'tp' ? files : null, imageKey: original === 'tp' ? null : original, imgWidth: imgwidth, imgHeight: imgheight, imgFilename: filename, imgThumb: thumb, imgCopyright: copyright, path })));
        };
    };
    // Wrapper for media tab selection with optional description update
    const handleMedia = (original, path, filename = '', thumb = '', copyright = '', files, description) => {
        if (description) {
            setImageDescription('description', description);
        }
        loadMedia(original, path, filename, thumb, copyright, files);
    };
    // Opens media selection library modal
    const handleClick = () => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showMedia: true, showImageEditor: false })));
    };
    // Triggers hidden file input for local computer uploads
    const handleFileUpload = (e, option) => {
        var _a;
        (_a = inputElement.current) === null || _a === void 0 ? void 0 : _a.click();
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showDescriptionInputField: option })));
    };
    // Closes Image Editor modal and resets editor state
    const handleIEclose = () => {
        if (inputElement.current) {
            inputElement.current.value = '';
        }
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showImageTooSmallError: false, showMedia: false, showImageEditor: false, editorImageSrc: null, xZoom: 1, rotation: 0, flipX: false, flipY: false })));
    };
    // Updates description text state
    const setImageDescription = (name, value) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { imageDescription: value })));
    };
    // Processes local file selection, evaluates EXIF orientation, normalizes image via HTML5 Canvas, and verifies resolution bounds
    const handleOnChange = (e) => {
        var _a;
        const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        const img = new Image();
        img.src = createObjectURL(file);
        img.onload = () => {
            const minwidth = state.imgBlockWidth;
            const minheight = state.imgBlockHeight;
            // Extract EXIF data to handle mobile camera rotation (e.g., iPhone orientation flags)
            EXIF.getData(file, function getExifData() {
                const Orientation = EXIF.getTag(this, 'Orientation');
                let imgwidth = img.width;
                let imgheight = img.height;
                // Validates dimensions and opens editor or prompts resolution error
                const processImage = (imageData, processedWidth, processedHeight) => {
                    if ((processedWidth < minwidth || processedHeight < minheight) && !allowSmallerImages) {
                        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showImageTooSmallError: true, showMedia: false })));
                    }
                    else if (processedWidth === minwidth &&
                        processedHeight === minheight &&
                        !clientImageRightsQuery &&
                        !allowSmallerImages) {
                        // Direct update if dimensions match target area exactly
                        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showImageTooSmallError: false, showMedia: false, showImageEditor: false })));
                        update(img.src, '');
                        imageUpload(id, file, null, attributes['data-name'], null, processedWidth, processedHeight);
                    }
                    else {
                        // Open editor modal for user cropping
                        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showImageTooSmallError: false, showMedia: false, imageKey: null, editorImageSrc: { src: typeof imageData === 'string' ? imageData : imageData.src }, imageSrc: file, imgWidth: processedWidth, imgHeight: processedHeight, showImageEditor: true })));
                    }
                    if (clientImageRightsQuery) {
                        imagePermissionQuery();
                    }
                };
                // Normalize image pixels using canvas transformation if EXIF orientation != 1
                if (Orientation && Orientation !== 1) {
                    const image = new Image();
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                        var _a;
                        if (typeof ((_a = ev.target) === null || _a === void 0 ? void 0 : _a.result) !== 'string')
                            return;
                        image.src = ev.target.result;
                        image.onload = () => {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');
                            const img_width = img.width;
                            const img_height = img.height;
                            switch (Orientation) {
                                case 3:
                                    canvas.width = img_width;
                                    canvas.height = img_height;
                                    ctx === null || ctx === void 0 ? void 0 : ctx.rotate(Math.PI);
                                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, -img_width, -img_height, img_width, img_height);
                                    break;
                                case 6:
                                    canvas.width = img_height;
                                    canvas.height = img_width;
                                    ctx === null || ctx === void 0 ? void 0 : ctx.rotate((3 * Math.PI) / 2);
                                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, -img_width, 0, img_width, img_height);
                                    imgwidth = img_height;
                                    imgheight = img_width;
                                    break;
                                case 8:
                                    canvas.width = img_height;
                                    canvas.height = img_width;
                                    ctx === null || ctx === void 0 ? void 0 : ctx.rotate(Math.PI / 2);
                                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, -img_height, img_width, img_height);
                                    imgwidth = img_height;
                                    imgheight = img_width;
                                    break;
                                default:
                                    canvas.width = img_width;
                                    canvas.height = img_height;
                                    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, 0, img_width, img_height);
                                    break;
                            }
                            const dataUrl = canvas.toDataURL('image/jpeg', 0.95);
                            const imgBlob = DataURIToBlob(dataUrl);
                            const imageUrl = createObjectURL(imgBlob);
                            processImage(imageUrl, imgwidth, imgheight);
                        };
                    };
                    reader.readAsDataURL(file);
                }
                else {
                    processImage(img, imgwidth, imgheight);
                }
            });
        };
    };
    const freeScale = attributes['data-freescale'];
    let originalSrc = '';
    if (typeof attributes['data-original'] !== 'undefined' && typeof attributes['data-thumb'] !== 'undefined') {
        originalSrc = S3_LINKS.MEDIA_IMGS_THUMB + attributes['data-thumb'];
    }
    // Inject overlay preview styling if layout template requires design boundaries
    const previewImageCss = attributes['data-pre']
        ? `
    .ReactCrop__crop-selection::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      background: url(${S3_LINKS.TEMPLATES}${templateId}/images/${attributes['data-pre']}) center no-repeat;
      background-size: 100% 100%;
      pointer-events: none;
    }
  `
        : '';
    let blob = false;
    if (getSrc().includes('blob')) {
        blob = true;
    }
    const index = _.findIndex(params, (param) => param.name === attributes['data-name']);
    const _filter = params[index] && params[index].filter !== undefined ? params[index].filter : '';
    const errors = params[index] && params[index].errors !== undefined ? params[index].errors : null;
    // Dynamic file type restrictions according to configured export type
    let allowedImageTypes = 'image/jpeg, image/png';
    const exportType = (_h = (_g = props.settings) === null || _g === void 0 ? void 0 : _g.export_type) === null || _h === void 0 ? void 0 : _h.value;
    if (exportType === '000000000000000000000003' || exportType === '000000000000000000000001') {
        allowedImageTypes = 'image/jpeg, image/png, image/webp';
    }
    return (_jsxs("div", { className: "editor-image-content dropbox", children: [_jsx(Tag, Object.assign({ ref: imageRef }, attributes, { src: getSrc(), style: { filter: _filter } })), blob && uploadError ? (_jsx("p", { className: "uploadError", "data-tooltip-content": messages.upload_failed, "data-tooltip-id": "top", children: _jsx("i", { className: "far fa-exclamation-triangle", title: messages.upload_failed }) })) : (_jsx(_Fragment, {})), (errors === null || errors === void 0 ? void 0 : errors.resolution_warning) ? (_jsx("p", { className: "uploadError", "data-tooltip-content": (_j = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _j === void 0 ? void 0 : _j.resolution_too_low, "data-tooltip-id": "top", children: _jsx("i", { className: "fa-thin fa-standard-definition", title: (_k = messages === null || messages === void 0 ? void 0 : messages.editor) === null || _k === void 0 ? void 0 : _k.resolution_too_low }) })) : (_jsx(_Fragment, {})), _jsx("div", { className: "fileclicker", onClick: handleClick, children: _jsxs("p", { children: [messages.editor.minimum_size, " ", imgBlockWidth, " x ", imgBlockHeight, " Pixel"] }) }), _jsx("input", { ref: inputElement, type: "file", accept: allowedImageTypes, onChange: handleOnChange }), showImageTooSmallError && (_jsx("div", { id: "infobox", children: _jsx(Alert, { children: messages.editor.too_low_resolution }) })), showMedia && (_jsx(ContextModal, { children: _jsx("div", { id: "contextModalWrap", children: _jsxs("div", { id: "contextModalStage", className: "row", children: [_jsx(MediaTabsFTs, { usedMedia: usedMedia, loadMedia: loadMedia, neededWidth: imgBlockWidth, neededHeight: imgBlockHeight, rootUser: rootUser, originalSrc: originalSrc, loadOriginal: loadOriginal, handleFileUpload: handleFileUpload, handleMedia: handleMedia, attributes: attributes['data-thumb'], saveDescription: saveDescription, handleIEclose: handleIEclose, handleOnChange: handleOnChange, allowSmallerImages: allowSmallerImages }), _jsx(Button, { variant: "danger", size: "lg", onClick: handleIEclose, className: "cancelIE", children: messages.editor.abort })] }) }) })), showImageEditor && (_jsxs(ContextModal, { children: [_jsx(EditorApplyStylesFTs, { styles: previewImageCss }), _jsx("div", { id: "contextModalWrap", children: _jsxs("div", { id: "contextModalStage", className: "image-editor", children: [_jsx(ImageEditorFTs, { editorImageSrc: editorImageSrc, scaleFree: state.scaleFree, freeScale: freeScale, imageUpload: imageUploadHandler, setCropperScaleFree: setCropperScaleFree, messages: messages, resetCropperImage: resetCropperImage, imgBlockWidth: imgBlockWidth, imgBlockHeight: imgBlockHeight, imgWidth: imgWidth, imgHeight: imgHeight, disabled: disabled, onImageLoaded: () => setIsEditorLoaded(true), handleIEclose: handleIEclose }), !isEditorLoaded && _jsx(Loader, { small: true }), showDescriptionInputField ? (_jsx(FormInput, { type: "text", label: messages.editor.image_description, name: "description", onChange: setImageDescription, value: imageDescription })) : null] }) }), _jsx(Tooltip, { id: "bottom", place: "bottom" })] }))] }));
};
const mapStateToProps = (state) => {
    var _a, _b;
    return ({
        appIntl: state.intl,
        clientImageRightsQuery: (_b = (_a = state.login.user) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.image_rights_query,
        editionRV: state.editor.editionRV,
    });
};
export default withRouter(connect(mapStateToProps)(legacyInjectIntl(ImageElementFTs)));
